// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9db942a7","239":"4f272d85","455":"83a77568"}[chunkId] + ".chunk.js";
};